import App from './components/App.vue'
window.FPI.extension.register("#whatsapp-notification-confirmation", {
  mounted(element) {
    window.FPI.extension.mountApp({
      element, 
      component: App,
    });
  }
})
